import React, { useState, useEffect } from 'react';
import { senderEmailAPI } from '../api';

function SenderEmails() {
  const [emails, setEmails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingEmail, setEditingEmail] = useState(null);
  const [newEmail, setNewEmail] = useState({ email: '', name: '', daily_cap: 50 });
  const [message, setMessage] = useState({ type: '', text: '' });

  useEffect(() => {
    loadEmails();
  }, []);

  const loadEmails = async () => {
    try {
      const response = await senderEmailAPI.getAll();
      if (response.data.success) {
        setEmails(response.data.data);
      }
    } catch (error) {
      console.error('加载发件邮箱失败:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingEmail) {
        const response = await senderEmailAPI.update(editingEmail.id, newEmail);
        if (response.data.success) {
          setMessage({ type: 'success', text: '✅ 更新成功！' });
          setShowModal(false);
          setEditingEmail(null);
          setNewEmail({ email: '', name: '', daily_cap: 50 });
          loadEmails();
          setTimeout(() => setMessage({ type: '', text: '' }), 3000);
        }
      } else {
        const response = await senderEmailAPI.add(newEmail);
        if (response.data.success) {
          const msg = response.data.message === '邮箱已恢复' 
            ? '✅ 邮箱已恢复并更新！' 
            : '✅ 添加成功！';
          setMessage({ type: 'success', text: msg });
          setShowModal(false);
          setNewEmail({ email: '', name: '', daily_cap: 50 });
          loadEmails();
          setTimeout(() => setMessage({ type: '', text: '' }), 3000);
        }
      }
    } catch (error) {
      setMessage({ type: 'error', text: (editingEmail ? '更新' : '添加') + '失败：' + (error.response?.data?.message || error.message) });
      setTimeout(() => setMessage({ type: '', text: '' }), 5000);
    }
  };

  const handleEdit = (email) => {
    setEditingEmail(email);
    setNewEmail({ email: email.email, name: email.name || '', daily_cap: email.daily_cap ?? 50 });
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('确定要删除这个发件邮箱吗？')) return;

    try {
      await senderEmailAPI.delete(id);
      setMessage({ type: 'success', text: '删除成功！' });
      loadEmails();
      setTimeout(() => setMessage({ type: '', text: '' }), 3000);
    } catch (error) {
      setMessage({ type: 'error', text: '删除失败：' + (error.response?.data?.message || error.message) });
    }
  };

  if (loading) {
    return <div>加载中...</div>;
  }

  return (
    <div>
      <div className="page-header">
        <h1>发件邮箱管理</h1>
        <p>管理您的发送邮箱地址</p>
      </div>

      {message.text && (
        <div className={`alert alert-${message.type}`}>
          {message.text}
        </div>
      )}

      <div className="card">
        <div className="card-header">
          <h2>发件邮箱列表</h2>
          <button className="btn btn-primary" onClick={() => {
            setEditingEmail(null);
            setNewEmail({ email: '', name: '', daily_cap: 50 });
            setShowModal(true);
          }}>
            + 添加发件邮箱
          </button>
        </div>

        {emails.length === 0 ? (
          <p style={{ textAlign: 'center', padding: '40px', color: '#999' }}>
            暂无发件邮箱，请添加一个
          </p>
        ) : (
          <table className="table">
            <thead>
              <tr>
                <th>邮箱地址</th>
                <th>显示名称</th>
                <th>每日上限</th>
                <th>状态</th>
                <th>添加时间</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              {emails.map((email) => (
                <tr key={email.id}>
                  <td>{email.email}</td>
                  <td>{email.name || '-'}</td>
                  <td>{email.daily_cap ?? 50} / 天</td>
                  <td>
                    <span className="badge badge-success">活跃</span>
                  </td>
                  <td>{new Date(email.created_at).toLocaleDateString()}</td>
                  <td>
                    <button
                      className="btn btn-primary"
                      style={{ padding: '5px 10px', fontSize: '12px', marginRight: '5px' }}
                      onClick={() => handleEdit(email)}
                    >
                      编辑
                    </button>
                    <button
                      className="btn btn-danger"
                      style={{ padding: '5px 10px', fontSize: '12px' }}
                      onClick={() => handleDelete(email.id)}
                    >
                      删除
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={() => {
          setShowModal(false);
          setEditingEmail(null);
          setNewEmail({ email: '', name: '', daily_cap: 50 });
        }}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>{editingEmail ? '编辑发件邮箱' : '添加发件邮箱'}</h2>
              <button className="modal-close" onClick={() => {
                setShowModal(false);
                setEditingEmail(null);
                setNewEmail({ email: '', name: '', daily_cap: 50 });
              }}>
                ×
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>邮箱地址 *</label>
                <input
                  type="email"
                  value={newEmail.email}
                  onChange={(e) => setNewEmail({ ...newEmail, email: e.target.value })}
                  placeholder="例如: ethan@serenejade.com"
                  required
                  disabled={!!editingEmail}
                />
              </div>

              <div className="form-group">
                <label>显示名称</label>
                <input
                  type="text"
                  value={newEmail.name}
                  onChange={(e) => setNewEmail({ ...newEmail, name: e.target.value })}
                  placeholder="例如: Ethan - SereneJade"
                />
              </div>

              <div className="form-group">
                <label>每日发送上限（这个邮箱独立的，按域名信誉单独暖机）</label>
                <input
                  type="number"
                  min="1"
                  value={newEmail.daily_cap}
                  onChange={(e) => setNewEmail({ ...newEmail, daily_cap: e.target.value })}
                  placeholder="例如: 50"
                />
              </div>

              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => {
                  setShowModal(false);
                  setEditingEmail(null);
                  setNewEmail({ email: '', name: '', daily_cap: 50 });
                }}>
                  取消
                </button>
                <button type="submit" className="btn btn-primary">
                  {editingEmail ? '更新' : '添加'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default SenderEmails;

